<script setup lang="ts">
import { EvmAddressDetailInfo } from '~/api/repository'
import { useFetchAddressDetail } from '~/api/service/address/[address]/index.service'
import { accountDetailPageType, portfolioPageType } from '~/routes/accounts'
import { ITab } from '~/types/tab.type'
import BcTabs from '~/ui/Tabs/BcTabs.vue'
import ADDRT = EvmAddressDetailInfo.ADDRT;
import { isSamePage } from '~/utils/route.util'

const route = useRoute()
const address = route.params.address as string

const { data } = useFetchAddressDetail(address)

type IAccountTab = ITab<accountDetailPageType> & {
  activeTypeList: Array<ADDRT>
}

const tabList = computed(() => {
  const tabs: Array<IAccountTab> = [
    {
      value: 'transactions',
      label: 'Transactions',
      activeTypeList: [ ADDRT.CA, ADDRT.EOA ],
    },
    {
      value: 'internal-transactions',
      label: 'Internal Transactions',
      activeTypeList: [ ADDRT.CA, ADDRT.EOA ],
    },
    {
      value: 'token-transfers',
      label: 'Token Transfers',
      activeTypeList: [ ADDRT.CA, ADDRT.EOA ],
    },
    {
      value: 'nft-transfers',
      label: 'NFT Transfers',
      activeTypeList: [ ADDRT.CA, ADDRT.EOA ],
    },
    {
      value: 'contract-code',
      label: 'Contract Code',
      activeTypeList: [ ADDRT.CA ],
    },
    {
      value: 'portfolio',
      label: 'Portfolio',
      activeTypeList: [ ADDRT.EOA, ADDRT.CA ],
    }
  ]
  return tabs.filter((tab: IAccountTab) => tab.activeTypeList.includes(data.value?.ADDRT || ADDRT.EOA))
})

const extractTabFromPath = (path: string) => {
  const pathParts = path.split('/')
  // portfolio/tokens 또는 portfolio/nfts 같은 경로에서 portfolio를 반환
  if (pathParts.includes('portfolio')) {
    return 'portfolio' as accountDetailPageType
  }
  return pathParts.at(-1) as accountDetailPageType || accountDetailPageType.transactions
}

const tab = ref(extractTabFromPath(route.path))

const router = useRouter()

onBeforeRouteUpdate((guard) => {
  if (isSamePage(guard.path, route.path)) {
    tab.value = extractTabFromPath(guard.path)
  }
})

watch(tab, () => {
  if (tab.value === 'portfolio') {
    router.replace(routes.getAccountDetailPageWithTab(address, tab.value, portfolioPageType.tokens))
  } else {
    router.replace(routes.getAccountDetailPageWithTab(address, tab.value))
  }
})
</script>

<template>
  <div>
    <BcTabs
      v-model="tab"
      :list="tabList"
    />
  </div>
</template>

<style scoped>

</style>